import { yupResolver } from "@hookform/resolvers/yup"
import {
  Accordion,
  Avatar,
  Button,
  FileInput,
  Group,
  Input,
  LoadingOverlay,
  Select,
  Tabs,
  Textarea,
  TextInput,
} from "@mantine/core"
import { useDisclosure, useId } from "@mantine/hooks"
import {
  IconArchive,
  IconArrowBackUp,
  IconCalendar,
  IconDeviceFloppy,
  IconTrash,
  IconUser,
} from "@tabler/icons-react"
import { debounce } from "lodash-es"
import { useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import InputMask from "react-input-mask"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import * as yup from "yup"
import ActivityLogWrapperComponent from "../../../shared/component/ActivityLog/activityLog-wrapper-component"
import Confirmation from "../../../shared/component/confirmation/action-confirmation"
import EmptyIcon from "../../../shared/component/empty-icon/empty-icon"
import { Constants } from "../../../shared/constants/Constants"
import { useLazyGetActivitiesQuery } from "../../../shared/store/query/sharedQuery"
import { downloadUrlParser } from "../../../shared/utility/Tools/tools"
import countryCodes from "../../../shared/utility/countryCodes.json"

import { DateInput } from "@mantine/dates"
import { IconUpload } from "@tabler/icons-react"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"
import { CollectionQuery } from "../../../models/collection.model"
import { Owner } from "../../../models/owner.model"
import { Property } from "../../../models/property.model"
import { Sale } from "../../../models/sales.model"
import { Unit } from "../../../models/unit.model"
import PushNotificationComponent from "../../../shared/component/push-notification/component/push-notification.component"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { onViewFile } from "../../../shared/utility/view-file"
import {
  useLazyGetPropertiesOfLeaseQuery,
  useLazyGetUnitsOfLeaseQuery,
} from "../../lease/store/lease.query"
import {
  useArchiveSaleMutation,
  useCreateSaleMutation,
  useDeleteSaleMutation,
  useLazyGetArchivedSaleQuery,
  useLazyGetOwnersOfSaleQuery,
  useLazyGetSaleQuery,
  useRemoveSalesFileMutation,
  useRestoreSaleMutation,
  useToggleSaleStatusMutation,
  useUpdateSaleMutation,
} from "../store/sale.query"
import { notification } from "../../../shared/component/notification/utility/notification"
import FileViewerModal from "../../../shared/component/file-viewer/file-viewer-modal.component"
import { flexiblePhoneRegEx } from "../../../shared/utility/Tools/RegEx"

// import OwnerFileUploadComponent from "./owner-file-upload.component";

interface Props {
  editMode: string
}

export default function NewSaleComponent(props: Props) {
  const { editMode } = props
  const id = useId()
  const { t } = useTranslation()
  const params = useParams()
  const location = useLocation()
  const [logo, setLogo] = useState<any>()
  const [emergencyCode, setEmergencyCode] = useState("+251")
  const currentUser: any = JSON.parse(
    localStorage.getItem("userInfo") as string,
  )
  const [opened, { open, close }] = useDisclosure()
  const [userInfo, currentUserId, ownerInfo, tenantInfo] = useCurrentUser()
  const [propertySearch, setPropertySearch] = useState<string | null>(null)
  const [unitSearch, setUnitSearch] = useState<string | null>(null)
  const [fileOpened, { open: fileOpen, close: fileClose }] = useDisclosure()
  const [selectedFiles, setSelectedFiles] = useState<string[]>([])

  const [propertiesCollection, setPropertiesCollection] =
    useState<CollectionQuery>({
      top: 10,
      skip: 0,
    })
  const [unitCollection, setUnitCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
  })
  let schema: any = yup.object().shape({
    buyerName: yup
      .string()
      .min(2, t("nameMin", { count: 2 }))
      .max(100, t("nameMax", { count: 100 }))
      .required(t("requiredValidation", { field: t("buyerName") })),

    buyerPhone: yup
      .string()
      .required(t("phoneRequired"))
      .matches(flexiblePhoneRegEx, t("validPhone")),
    propertyId: yup
      .string()
      .required(
        t("requiredValidation", { field: t("property", { count: 1 }) }),
      ),
    unitId: yup
      .string()
      .required(t("requiredValidation", { field: t("unit", { count: 1 }) })),

    // identification: yup.mixed().when([], (boloDueDate: any, schema: any) => {
    //   if (editMode == "new" && !tenant?.data?.minoioIdentification) {
    //     return schema
    //       .required(t("identificationRequired"))
    //       .test(
    //         "fileSize",
    //         t("identificationSize", { size: "2MB" }),
    //         (value: any) => {
    //           return value && value?.size <= 2000000
    //         },
    //       )
    //       .test("type", t("identificationType"), (value: any) => {
    //         return (
    //           (value && value.type === "image/jpg") ||
    //           value.type === "image/jpeg" ||
    //           value.type === "image/png"
    //         )
    //       })
    //   }
    // }),
  })

  const defaultValue: Sale = {
    id: "",
    propertyId: "",
    unitId: "",
    buyerName: "",
    buyerPhone: "",
    notes: "",
  }

  const [getSale, sale] = useLazyGetSaleQuery()
  const [createSale, newSale] = useCreateSaleMutation()
  const [updateSale, updateResponse] = useUpdateSaleMutation()
  const [restoreSale, restoredSale] = useRestoreSaleMutation()
  const [deleteSale, deleteResponse] = useDeleteSaleMutation()
  const [getActivities, activities] = useLazyGetActivitiesQuery()
  const [archiveSale, archiveResponse] = useArchiveSaleMutation()
  const [toggleStatus, toggleStatusResponse] = useToggleSaleStatusMutation()
  const [getArchivedSale, archivedSale] = useLazyGetArchivedSaleQuery()
  const [getOwners, owners] = useLazyGetOwnersOfSaleQuery()
  const [removeSalesFile, removeSalesFileResponse] =
    useRemoveSalesFileMutation()
  const [getProperties, properties] = useLazyGetPropertiesOfLeaseQuery()
  const [getUnits, units] = useLazyGetUnitsOfLeaseQuery()
  const {
    register,
    setValue,
    getValues,
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<Sale>({
    resolver: yupResolver(schema),
    mode: "all",
  })

  const navigate = useNavigate()

  const [userId, setUserId] = useState("")
  const [code, setCode] = useState("+251")
  const [data] = useState<any>(countryCodes)
  const [citySelection, setCitySelection] = useState<string>("")

  const [isCompanyClicked, setIsCompanyClicked] = useState<boolean>(false)

  const [ownerSearch, setOwnerSearch] = useState<string | null>(null)
  const [ownersCollection, setOwnersCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
  })

  useEffect(() => {
    if (editMode === "detail") {
      if (params?.type && params?.type === "archived") {
        getArchivedSale(`${params?.id}`).then((response: any) => {
          setLogo(response.data.logo)
          setIsCompanyClicked(response.data?.isCompany)
          reset({
            ...response.data,
            soldAt: response?.data?.soldAt
              ? new Date(response?.data?.soldAt)
              : null,
          })
          setUserId(response.data.id)
        })
      } else {
        getSale(`${params?.id}`).then((response: any) => {
          setLogo(response.data.logo)
          // setIsCompanyClicked(response.data?.isCompany);
          reset({
            ...response.data,
            soldAt: response?.data?.soldAt
              ? new Date(response?.data?.soldAt)
              : null,
          })
          setUserId(response?.data?.id as string)
          // setValue('phoneNumber', response?.data?.phoneNumber as string)
          // setValue('emergencyContact.phoneNumber', response?.data?.emergencyContact?.phoneNumber as string)
        })
      }
    } else {
      reset(defaultValue)
      setIsCompanyClicked(false)
    }
  }, [params, editMode, getSale])

  useEffect(() => {
    getOwners({
      ...ownersCollection,
      filter: [[{ field: "name", operator: "like", value: ownerSearch }]],
    })
  }, [ownerSearch])
  useEffect(() => {
    getOwners(ownersCollection)
  }, [ownersCollection])

  const propertyWatch = watch("propertyId")

  useEffect(() => {
    if (userInfo?.role?.key == "super_admin") {
      getProperties(propertiesCollection)
    } else if (userInfo?.role?.key == "tenant") {
      getProperties({
        ...propertiesCollection,
        filter: [
          [
            {
              field: "ownerId",
              value: tenantInfo?.ownerId,
              operator: "=",
            },
          ],
        ],
      })
    } else {
      getProperties({
        ...propertiesCollection,
        filter: [
          [
            {
              field: "ownerId",
              value: ownerInfo?.parentOwnerId,
              operator: "=",
            },
          ],
        ],
      })
    }
  }, [propertiesCollection])
  useEffect(() => {
    if (propertyWatch) {
      getUnits({
        ...unitCollection,
        filter: [
          [
            {
              field: "propertyId",
              operator: "=",
              value: propertyWatch,
            },
          ],
        ],
      })
    }
  }, [unitCollection, propertyWatch])

  useEffect(() => {
    if (propertySearch) {
      if (userInfo?.role?.key == "super_admin") {
        getProperties({
          ...propertiesCollection,
          filter: [
            [{ field: "name", operator: "like", value: propertySearch }],
          ],
        })
      } else if (userInfo?.role?.key == "tenant") {
        getProperties({
          ...propertiesCollection,
          filter: [
            [{ field: "name", operator: "like", value: propertySearch }],
            [
              {
                field: "ownerId",
                operator: "=",
                value: tenantInfo?.ownerId,
              },
            ],
          ],
        })
      } else {
        getProperties({
          ...propertiesCollection,
          filter: [
            [{ field: "name", operator: "like", value: propertySearch }],
            [
              {
                field: "ownerId",
                operator: "=",
                value: ownerInfo?.parentOwnerId,
              },
            ],
          ],
        })
      }
    }
  }, [propertySearch])
  useEffect(() => {
    if (propertyWatch && unitSearch) {
      getUnits({
        ...unitCollection,
        filter: [
          [{ field: "name", operator: "like", value: unitSearch }],
          [{ field: "propertyId", operator: "=", value: propertyWatch }],
        ],
      })
    }
  }, [unitSearch])

  // useEffect(() => {
  //   if (isCompanyClicked) {
  //     setValue("gender", "");
  //   }
  // }, [isCompanyClicked, setValue]);

  function handleFileRemoval(item: string) {
    removeSalesFile({
      saleId: sale?.data?.id as string,
      filename: item,
    }).then((response) => {
      notification("success", "File removed Successfully")
    })
  }
  function onSubmit(data: any) {
    try {
      const formData = new FormData()

      // if (currentUser?.role?.key != "super_admin") {
      //   formData.append("ownerId", currentUser?.id as string)
      // } else {
      //   formData.append("ownerId", data?.ownerId as string)
      // }
      // formData.append("id", data?.id as string);
      data.soldAt = data?.soldAt ? new Date(data?.soldAt) : null
      formData.append("buyerName", data?.buyerName as string)
      formData.append(
        "buyerPhone",
        data?.buyerPhone?.split(" ")?.join("") as string,
      )
      formData.append("amount", data?.amount?.toString() as string)
      formData.append("propertyId", data?.propertyId as string)
      formData.append("unitId", data?.unitId as string)
      formData.append("soldAt", dayjs(data?.soldAt).format())
      // formData.append("file", data?.file)
      if (data.files && data.files.length > 0) {
        data.files.forEach((file: any) => {
          formData.append("files", file)
        })
      }
      formData.append("notes", data?.notes as string)

      if (editMode === "new") {
        createSale(formData).then((response: any) => {
          if (!response?.error) {
            reset(defaultValue)
          }
        })
      } else {
        // const tenant: Tenant = {
        //   id: params.id,
        //   ...data,
        //   phoneNumber: data.phoneNumber.split(" ").join(""),
        // };
        formData.append("id", params?.id as string)
        // data.id = params?.id as string;
        updateSale(formData)
      }
    } catch (e: any) {
      console.log("🚀 ~ onSubmit ~ e:", e)
    }
  }
  const onError = (error: any) => {
    console.log("🚀 ~ onError ~ error:", error)
  }

  function _parsePropertyOwners() {
    let data: { label: string; value: string }[] = []

    owners?.data?.data?.map((owner: Owner) => {
      data.push({ label: owner?.name as string, value: owner?.id as string })
    })

    return data
  }

  function _parseProperties() {
    let data: { label: string; value: string }[] = []

    properties?.data?.data?.map((property: Property) => {
      data.push({
        label: property?.name as string,
        value: property?.id as string,
      })
    })
    return data
  }
  function _parseUnits() {
    let data: { label: string; value: string }[] = []

    units?.data?.data?.map((unit: Unit) => {
      data.push({ label: unit?.name as string, value: unit?.id as string })
    })

    return data
  }

  return (
    // <div className="h-full relative w-full dark:bg-gray-700 dark:text-white flex space-x-2 justify-center">
    <ActivityLogWrapperComponent
      title={
        editMode === "new" ? (
          <>
            {t("new")} {t("sale", { count: 1 })}
          </>
        ) : (
          <div className="h-full space-x-2 flex flex-col sm:flex-row items-center">
            {logo && (
              <>
                <Avatar
                  src={downloadUrlParser({
                    path: logo?.path,
                    filename: logo?.filename,
                    originalname: logo?.originalname,
                    mimetype: logo?.mimetype,
                  })}
                  alt="photo"
                />
              </>
            )}

            <div>
              {sale?.data?.property?.name}-{sale?.data?.unit?.name}
            </div>
          </div>
        )
      }
      item={sale}
      path={`/sale/detail/${params?.type}/${params.id}`}
      id={params.id ?? ""}
    >
      <LoadingOverlay
        visible={
          (editMode === "new" ? newSale.isLoading : updateResponse.isLoading) ||
          sale.isLoading
        }
      />
      <>
        <Tabs defaultValue="sale">
          <Tabs.List>
            <Tabs.Tab value="sale" icon={<IconUser size={14} />}>
              {t("basicSaleInfo")}
            </Tabs.Tab>
            {/* {editMode === "detail" && (
                <Tabs.Tab value="document" icon={<IconFilePlus size={14} />}>
                  Upload document
                </Tabs.Tab>
              )} */}
          </Tabs.List>

          <Tabs.Panel value="sale" pt="xs">
            <div className="flex  justify-center h-full">
              <form
                onSubmit={handleSubmit(onSubmit, onError)}
                className="w-full gap-y-4 dark:text-white"
              >
                <Accordion
                  defaultValue={["info", "address", "emergency"]}
                  multiple
                  variant="separated"
                  classNames={{
                    control:
                      "bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg shadow-lg rounded-xl border border-gray-700",
                  }}
                >
                  <Accordion.Item value="info">
                    <Accordion.Control>{t("basicSaleInfo")}</Accordion.Control>
                    <Accordion.Panel className="bg-gray-800">
                      <div className="flex-col space-y-4">
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <TextInput
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={
                              errors.buyerName &&
                              `${errors?.buyerName?.message}`
                            }
                            withAsterisk
                            label={t("buyerName")}
                            placeholder={t("buyerName")}
                            {...register("buyerName")}
                          />
                          {/* <div className="flex w-full">
                            <Select
                              radius={"xs"}
                              searchable
                              nothingFound={
                                <div className="fle w-full justify-center items-center">
                                  <EmptyIcon />
                                </div>
                              }
                              onChange={(code) => {
                                code && setCode(code)
                              }}
                              classNames={{
                                input:
                                  "border border-gray-400/70 border-r-0 rounded rounded-r-none",
                              }}
                              value={code}
                              label={t("code")}
                              data={data?.map((item: any) => ({
                                label: `${item.name} (${item.dial_code})`,
                                value: item.dial_code,
                                key: item.name,
                              }))}
                              maxDropdownHeight={400}
                            />
                            <Input.Wrapper
                              id={id}
                              className="w-full"
                              label={t("phoneNumber")}
                              required
                              error={
                                errors.buyerPhone &&
                                `${errors?.buyerPhone?.message}`
                              }
                            >
                              <Input
                                classNames={{ input: "rounded-l-none" }}
                                component={InputMask}
                                mask={`${code} 999 999 999`}
                                id={id}
                                placeholder={t("buyerPhone")}
                                {...register("buyerPhone")}
                              />
                            </Input.Wrapper>
                          </div> */}

                          <TextInput
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={errors?.buyerPhone && `${errors?.buyerPhone?.message}`}
                            withAsterisk
                            label={t("buyerPhone")}
                            placeholder={t("buyerPhone")}
                            {...register("buyerPhone")}
                          />
                        </div>
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <Controller
                            control={control}
                            name="propertyId"
                            render={({ field }) => (
                              <Select
                                classNames={{ label: "dark:text-white mb-5" }}
                                className="w-full"
                                onKeyDown={debounce(
                                  (event: any) =>
                                    setPropertySearch(event?.target?.value),
                                  1000,
                                )}
                                searchable
                                clearable
                                withAsterisk
                                error={
                                  errors.propertyId &&
                                  `${errors?.propertyId?.message}`
                                }
                                label={t("property", { count: 1 })}
                                placeholder={t("property", { count: 1 })}
                                data={_parseProperties()}
                                {...field}
                              />
                            )}
                          />

                          <Controller
                            control={control}
                            name="unitId"
                            render={({ field }) => (
                              <Select
                                classNames={{ label: "dark:text-white" }}
                                className="w-full"
                                withAsterisk
                                onKeyDown={debounce(
                                  (event: any) =>
                                    setUnitSearch(event?.target?.value),
                                  1000,
                                )}
                                searchable
                                clearable
                                error={
                                  errors.unitId && `${errors?.unitId?.message}`
                                }
                                description={t("unitDesc")}
                                label={t("unit", { count: 1 })}
                                placeholder={t("unit", { count: 1 })}
                                data={_parseUnits()}
                                {...field}
                              />
                            )}
                          />
                        </div>
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <TextInput
                            classNames={{ label: "dark:text-white mb-3.5" }}
                            className="w-full"
                            error={
                              errors.amount && `${errors?.amount?.message}`
                            }
                            type="number"
                            withAsterisk
                            label={t("amount")}
                            placeholder={t("amount")}
                            {...register("amount")}
                          />

                          <Controller
                            control={control}
                            name="soldAt"
                            disabled={userInfo?.role?.key === "tenant"}
                            render={({ field }) => (
                              <DateInput
                                icon={<IconCalendar size={16} />}
                                className="w-full mt-3"
                                {...field}
                                // excludeDate={(edate) => {
                                //   if (edate.getFullYear() < date.getFullYear()) {
                                //     return true;
                                //   } else if (
                                //     edate.getFullYear() === date.getFullYear() &&
                                //     edate.getMonth() < date.getMonth()
                                //   ) {
                                //     return true;
                                //   } else {
                                //     if (
                                //       edate.getFullYear() <= date.getFullYear() &&
                                //       edate.getMonth() === date.getMonth() &&
                                //       edate.getDate() <= date.getDate()
                                //     ) {
                                //       return true;
                                //     } else {
                                //       return false;
                                //     }
                                //   }
                                // }}
                                error={
                                  errors.soldAt && `${errors.soldAt?.message}`
                                }
                                label={t("soldAt")}
                                withAsterisk
                              />
                            )}
                          />
                        </div>
                        <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                          <div className="flex w-full  space-x-4  justify-between">
                            <div className="w-full">
                              <Controller
                                control={control}
                                name="files"
                                render={({ field }) => (
                                  <FileInput
                                    withAsterisk
                                    clearable
                                    multiple
                                    className="w-full"
                                    error={
                                      errors.files && `${errors.files?.message}`
                                    }
                                    label={t("file")}
                                    //@ts-ignore
                                    placeholder={t("file")}
                                    icon={<IconUpload size={14} />}
                                    {...field}
                                  />
                                )}
                              />
                              {sale?.data?.minioFiles &&
                                sale?.data?.minioFiles?.length > 0 && (
                                  <span
                                    onClick={() => {
                                      setSelectedFiles(
                                        sale?.data?.fileNames as string[],
                                      )
                                      fileOpen()
                                    }}
                                    className=" cursor-pointer text-xs text-primary my-4"
                                  >
                                    {/* {t("view")} */}

                                    <p>
                                      View (
                                      {sale?.data?.minioFiles?.length ?? 0})
                                      files.
                                    </p>
                                  </span>
                                )}
                            </div>
                          </div>
                          <Textarea
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            error={errors.notes && `${errors?.notes?.message}`}
                            withAsterisk
                            label={t("description")}
                            placeholder={t("description")}
                            {...register("notes")}
                          />
                        </div>
                      </div>
                    </Accordion.Panel>
                  </Accordion.Item>
                </Accordion>

                <div className="w-full flex justify-end items-center">
                  <Group position="right" mt="xl">
                    {editMode === "new" && (
                      <>
                        <Button
                          classNames={{ label: "flex space-x-1 " }}
                          variant="default"
                          className="dark:text-white hover:bg-primary hover:dark:bg_dark_primary hover:text-white"
                          type="reset"
                          size="xs"
                        >
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="fill-current h-6"
                              viewBox="0 0 32 32"
                            >
                              <path d="M18.90625 4.09375C18.101563 4.09375 17.265625 4.367188 16.625 4.9375L16.625 4.96875L16.59375 5L4.90625 16.59375C3.695313 17.804688 3.703125 19.777344 4.84375 21.0625L4.875 21.09375L4.90625 21.09375L10.90625 27.09375C11.511719 27.699219 12.320313 27.992188 13.125 28L28 28L28 26L16.5 26L27 15.5C28.265625 14.234375 28.304688 12.210938 27.09375 11L21.09375 5C20.488281 4.394531 19.710938 4.09375 18.90625 4.09375 Z M 18.875 6.125C19.195313 6.125 19.492188 6.210938 19.6875 6.40625L25.6875 12.40625C26.074219 12.792969 26.128906 13.558594 25.59375 14.09375L20.5625 19.125L12.90625 11.46875L17.96875 6.4375L18 6.40625C18.253906 6.195313 18.570313 6.125 18.875 6.125 Z M 11.46875 12.90625L19.125 20.5625L14.03125 25.65625C14.019531 25.664063 14.011719 25.679688 14 25.6875C13.484375 26.117188 12.691406 26.066406 12.3125 25.6875L6.34375 19.75C6.328125 19.730469 6.328125 19.707031 6.3125 19.6875C5.902344 19.171875 5.9375 18.375 6.3125 18Z" />
                            </svg>
                          </span>
                          <span>{t("reset")}</span>
                        </Button>
                        <Button
                          variant="filled"
                          className="bg-primary text-white"
                          type="submit"
                          classNames={{ label: "flex space-x-1" }}
                          size={"xs"}
                          loading={newSale.isLoading}
                        >
                          <span>
                            <IconDeviceFloppy size={22} strokeWidth={1.5} />
                          </span>
                          <span>{t("submit")}</span>
                        </Button>
                      </>
                    )}
                    {editMode === "detail" && (
                      <>
                        {(params?.type === "archived" &&
                          archivedSale?.data?.deletedAt) ||
                          (params?.type === "active" && sale?.data?.deletedAt) ? (
                          <>
                            <Confirmation
                              type={"danger"}
                              message={t("permanentDeleteMessage")}
                              onYes={() => deleteSale(`${params?.id}`)}
                              header={t("permanentDeleteTitle")}
                            >
                              <Button
                                variant="filled"
                                loading={deleteResponse.isLoading}
                                className={`bg-danger text-white flex space-x-2 items-center`}
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <IconTrash size={20} strokeWidth={1.5} />
                                <span>{t("delete")}</span>{" "}
                              </Button>
                            </Confirmation>
                            <Confirmation
                              type={"notify"}
                              message={t("restoreMessage")}
                              onYes={() => restoreSale(`${params?.id}`)}
                              header={t("restoreTitle")}
                            >
                              <Button
                                variant="filled"
                                loading={restoredSale.isLoading}
                                className={`bg-green-500 text-white flex space-x-2 items-center`}
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <IconArrowBackUp size={20} strokeWidth={1.5} />
                                <span>{t("restore")}</span>
                              </Button>
                            </Confirmation>
                          </>
                        ) : (
                          <>
                            {" "}
                            <Confirmation
                              type={"notify"}
                              message={t("archiveMessage", {
                                model: t("tenant", { count: 1 }),
                              })}
                              header={t("archiveTitle", {
                                name: `${sale?.data?.property?.name}-${sale?.data?.unit?.name}`,
                              })}
                              result={"single"}
                              resultRequired={true}
                              selectorLabel={t("selectAReason", {
                                model: t("tenant", { count: 1 }),
                              })}
                              labelDescription={t("archiveWhy", {
                                model: t("tenant", { count: 1 }),
                              })}
                              options={Constants(t)?.ArchiveReason?.map(
                                (reason) => {
                                  return { label: reason, value: reason }
                                },
                              )}
                              customInput={true}
                              yesText={t("archive")}
                              onYes={(reason: string) => {
                                archiveSale({
                                  id: `${params.id}`,
                                  reason: reason,
                                })
                              }}
                            >
                              <Button
                                variant="filled"
                                loading={archiveResponse.isLoading}
                                className="bg-danger text-white"
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <span>
                                  <IconArchive size={22} strokeWidth={1.5} />
                                </span>
                                <span>{t("archive")}</span>
                              </Button>
                            </Confirmation>
                            <Button
                              variant="filled"
                              className="bg-primary text-white"
                              type="submit"
                              classNames={{ label: "flex space-x-1" }}
                              size={"xs"}
                              loading={updateResponse.isLoading}
                            >
                              <span>
                                <IconDeviceFloppy size={22} strokeWidth={1.5} />
                              </span>
                              <span>{t("update")}</span>
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  </Group>
                </div>
              </form>
            </div>
          </Tabs.Panel>

          {/* <Tabs.Panel value="document" pt="xs">
              <div className="flex-col w-full space-y-4">
                <OwnerFileUploadComponent />
              </div>
            </Tabs.Panel> */}
        </Tabs>
      </>

      <PushNotificationComponent open={open} opened={opened} close={close} />

      <FileViewerModal
        open={fileOpen}
        close={fileClose}
        fileType={t("sale", { count: 1 })}
        files={selectedFiles as string[]}
        opened={fileOpened}
        remove={handleFileRemoval}
        removeLoading={removeSalesFileResponse?.isLoading}
        fileNames={sale?.data?.fileNames as string[]}
      />
    </ActivityLogWrapperComponent>
    // </div >
  )
}
